const handleDeleteEquipmentServiceFail = {
  title: 'SERVICE CANNOT BE DELETED',
  message: 'Cannot be deleted. Used by',
  companies: 'Companies',
  items: 'Items',
  equipmentmodels: 'Equipament Models',
  equipments: 'Equipments',
  inspections: 'Inspections',
  itemverifications: 'Verification Items',
  default: 'Generic Colelction'
};

export default handleDeleteEquipmentServiceFail;
